module.exports = __webpack_public_path__ + "img/person3.6f9227fa.png";